import React, {useEffect, useState} from "react";
import _ from "lodash";
import XMarkIcon from "@heroicons/react/24/solid/XMarkIcon";
import {SEARCH_TARGETING_INPUT_FIELDS} from "../../constants/targeting.constant";
import RenderFields from "../../../common/ui/render-fields";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import {handleFieldValueChanges, prepareInputFields} from "../../../common/utils/field-change-util";
import {addSingleTargeting, updateSingleTargeting} from "../../services/facebook-targeting-data.service";
import {searchTargeting} from "../../services/facebook-ads-service";
import {
    FACEBOOK_SEARCH_TARGETING_LOCATION_TYPES,
    FACEBOOK_SEARCH_TARGETING_TYPES
} from "../../constants/facebook-constant";
import SearchTargetingFilters from "./search-targeting-filters";

const DEFAULT_TARGETING_SEARCH: any = {
    query: '',
    type: FACEBOOK_SEARCH_TARGETING_TYPES.INTEREST
}

const SearchTargetingInterest = ({
                                     searchTextList = [],
                                     afterSearch = undefined
                                 }) => {
    const [searchResultsMap, setSearchResultsMap] = useState({});
    const [searchInProgress, setSearchInProgress] = useState(false);

    const startTargetSearch = async () => {
        if (_.isEmpty(searchTextList)) {
            return;
        }

        setSearchInProgress(true);
        let existingSearchResultsMap = {...searchResultsMap};

        const newSearchFilter = DEFAULT_TARGETING_SEARCH;

        await Promise.all(searchTextList.map(async (searchText) => {
            newSearchFilter.query = searchText;
            const searchResults = await searchTargeting(newSearchFilter);
            const searchResultsByIdMap = _.keyBy(searchResults, 'id');
            existingSearchResultsMap = {...existingSearchResultsMap, ...searchResultsByIdMap};
        }));

        if (afterSearch) {
            afterSearch(existingSearchResultsMap);
        }

        setSearchInProgress(false);
    }

    return (
        <>
            {searchTextList.length > 0 &&
                <button
                    className="button-green px-2 py-1 flex items-center justify-center"
                    onClick={startTargetSearch}>
                    Search Interest Targeting <div className={''}>
                    <ShowProgressSpinner
                        sizeClass={'w-5 h-5 ml-2'}
                        dataFetchInProgress={searchInProgress}/>
                </div>
                </button>
            }
        </>
    );
}

export default SearchTargetingInterest
